<template>
    <svg
        id="icon_smallscreen"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="30"
        height="30"
        viewBox="0 0 30 30"
    >
        <defs>
            <linearGradient
                id="linear-gradient"
                x1="0.5"
                x2="0.5"
                y2="1"
                gradientUnits="objectBoundingBox"
            >
                <stop offset="0" stop-color="#fff" />
                <stop offset="1" stop-color="#e3bdff" />
            </linearGradient>
        </defs>
        <path
            id="icon_smallscreen-2"
            data-name="icon_smallscreen"
            d="M2239-477h-22a4,4,0,0,1-4-4v-22a4,4,0,0,1,4-4h22a4,4,0,0,1,4,4v22A4,4,0,0,1,2239-477Zm-17-6.393V-479h3v-10h-9v3h4.364L2216-481.636l2.12,2.121,3.877-3.876ZM2231-504v10h9v-3h-4.363l4.363-4.364-2.121-2.121L2234-499.606V-504Z"
            transform="translate(-2213 507)"
            fill="url(#linear-gradient)"
        />
    </svg>
</template>
